import { useState } from "react";

import { makeStyles } from "@material-ui/core/styles";
import {
  Card,
  Grid,
  Box,
  Typography,
  Divider,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Button,
} from "@material-ui/core";

import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

import DialogSelectProductDesireConsumidor360 from "../components/dialog-select-product";
import componentStyles from "assets/theme/views/admin/react-bs-table.js";
import ImagePlaceholder from "components/Image/ImagePlaceholder";

const useStyles = makeStyles(componentStyles);

export default function DesireProducts({
  isMobile500,
  isMobile,
  desireProduct,
  cpf,
  idLoja,
  idVendedor,
  customerDetail,
  setHasUpdatedDesireProduct,
}) {
  const classes = useStyles();
  const [expanded, setExpanded] = useState(false);
  const [openDialog, setOpenDialog] = useState(false);

  const handleChange = (panel) => (event, isExpanded) => {
    setExpanded(isExpanded ? panel : false);
  };

  return (
    <Grid
      container
      style={{
        display: "flex",
        justifyContent: "center",
        alignItems: "baseline",
      }}
    >
      <Grid item xs={12}>
        <Card classes={{ root: classes.cardRoot }} style={{ display: "flex" }}>
          <Grid
            item
            xs={12}
            style={{
              marginTop: "0.75rem",
              display: "flex",
              flexDirection: isMobile500 ? "column" : "row",
              justifyContent: "space-between",
              alignItems: isMobile500 ? "flex-start" : "center",
            }}
          >
            <Box component={Typography} variant="h3" marginBottom="0!important">
              <Box component="span">Produtos de Desejo</Box>
            </Box>
            <Box component={Typography} variant="h3" marginBottom="0!important">
              <Button
                style={{ marginTop: isMobile500 ? "0.75rem" : 0 }}
                variant="contained"
                onClick={() => setOpenDialog(true)}
              >
                Selecionar Produto
              </Button>
            </Box>
          </Grid>
          <Divider style={{ margin: "0.85rem 0" }} />
          <Grid item xs={12}>
            {desireProduct?.map((item) => (
              <Accordion
                key={item?.Id}
                expanded={expanded === item?.Id}
                onChange={handleChange(item?.Id)}
              >
                <AccordionSummary
                  expandIcon={<ExpandMoreIcon />}
                  aria-controls="panel1a-content"
                  id="panel1a-header"
                >
                  <Typography variant="body2">
                    <span style={{ fontWeight: "600" }}>Nome: </span>{" "}
                    {item?.DescricaoProduto}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails
                  style={{ display: "flex", flexDirection: "column" }}
                >
                  <Divider style={{ marginBottom: "0.75rem" }} />
                  <Grid
                    item
                    xs={12}
                    style={{ display: "flex", flexDirection: "column" }}
                  >
                    <Typography variant="body2">
                      <span style={{ fontWeight: "600" }}>Nome da Loja: </span>{" "}
                      {item?.NomeLoja}
                    </Typography>
                    <Typography variant="body2" style={{ margin: "0.5rem 0" }}>
                      <span style={{ fontWeight: "600" }}>
                        Nome do Vendedor:{" "}
                      </span>{" "}
                      {item?.NomeVendedor}
                    </Typography>
                    <Typography variant="body2">
                      <span style={{ fontWeight: "600" }}>
                        Data do Registro:{" "}
                      </span>{" "}
                      {item?.DataContatoFormat}
                    </Typography>
                    <Typography variant="body2" style={{ margin: "0.5rem 0" }}>
                      <span style={{ fontWeight: "600" }}>Observações: </span>{" "}
                      {item?.Obs}
                    </Typography>
                    <Typography variant="body2" style={{ margin: "0.5rem 0" }}>
                      <span style={{ fontWeight: "600" }}>
                        Produto de Desejo:{" "}
                      </span>
                    </Typography>
                    <Grid
                      item
                      xs={12}
                      style={{
                        display: "flex",
                        flexDirection: isMobile500 ? "column" : "row",
                      }}
                    >
                      <Grid
                        item
                        xs={2}
                        style={{ display: "flex", alignItems: "center" }}
                      >
                        <ImagePlaceholder
                          src={item?.Foto}
                          alt="Foto do produto"
                          width={50}
                          widthOnError={40}
                          imagePreviewTitle={`Produto ${item?.Id}`}
                        />
                      </Grid>
                      <Grid item xs={isMobile500 ? 12 : 10}>
                        <Typography
                          variant="body2"
                          style={{ fontWeight: "650" }}
                        >
                          {item?.DescricaoProduto}
                        </Typography>
                        <Typography
                          variant="body2"
                          style={{ fontSize: "0.85rem", margin: "0.4rem 0" }}
                        >
                          Código: {item?.RefBasica}
                        </Typography>
                        <Typography
                          variant="body2"
                          style={{ fontSize: "0.85rem" }}
                        >
                          EAN: {item?.Ean}
                        </Typography>
                      </Grid>
                    </Grid>
                  </Grid>
                  <Divider style={{ margin: "0.7rem 0" }} />
                </AccordionDetails>
              </Accordion>
            ))}
          </Grid>
        </Card>
      </Grid>
      {openDialog && (
        <DialogSelectProductDesireConsumidor360
          setHasUpdatedDesireProduct={setHasUpdatedDesireProduct}
          open={openDialog}
          onClose={() => setOpenDialog(false)}
          cpf={cpf}
          idLoja={idLoja}
          idVendedor={idVendedor}
          customerDetail={customerDetail}
          isMobile={isMobile}
        />
      )}
    </Grid>
  );
}
